export default {
    getMenuList(state) {
        return state.menuList
    },
    getAdditionalLinks(state) {
        return state.additionalLinks
    }
}